"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationOptions = void 0;
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_1 = __importDefault(require("vue"));
var DataService_1 = require("@app/services/DataService");
var PaginationOptions = /** @class */ (function () {
    function PaginationOptions() {
        this.currentPage = 1;
        this.itemsPerPage = 20;
        this.sortBy = 'id';
        this.sortByDesc = false;
        this.totalItems = 0;
        this.search = '';
        this.filter = [];
    }
    return PaginationOptions;
}());
exports.PaginationOptions = PaginationOptions;
var DataList = /** @class */ (function (_super) {
    __extends(DataList, _super);
    function DataList() {
        var _this = _super.call(this) || this;
        _this.loading = false;
        _this.selected = [];
        _this.items = [];
        _this.options = new PaginationOptions();
        return _this;
    }
    DataList.prototype.setPage = function () {
        this.getItems(this.options);
    };
    DataList.prototype.reloadItemsPerPage = function () {
        this.getItems(this.options);
    };
    DataList.prototype.updateFilter = function () {
        this.getItems(this.options);
    };
    DataList.prototype.updateSortBy = function () {
        this.getItems(this.options);
    };
    DataList.prototype.updateSortByDesc = function () {
        this.getItems(this.options);
    };
    DataList.prototype.setFilter = function (key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            var filter = new DataService_1.SimpleFilter(key, value);
            this.options.filter.push(filter);
        }
    };
    DataList.prototype.clearFilterByKey = function (key) {
        for (var i = 0; i < this.options.filter.length; i++) {
            if (this.options.filter[i].key == key) {
                this.options.filter.splice(i, 1);
            }
        }
        return false;
    };
    DataList.prototype.clearFilter = function () {
        this.options.filter = [];
    };
    DataList.prototype.getItems = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.service) return [3 /*break*/, 2];
                        this.loading = true;
                        window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                        return [4 /*yield*/, this.service.getItems(options.currentPage, options.itemsPerPage, options.sortBy, options.sortByDesc, options.search, options.filter)];
                    case 1:
                        response = _a.sent();
                        this.items = response.items;
                        this.options.totalItems = response.meta.total;
                        this.loading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataList.prototype.getAppUrl = function () {
        return process.env.APP_URL;
    };
    DataList.prototype.getUrl = function (path) {
        if (this.getAppUrl()) {
            return this.getAppUrl() + '/' + path;
        }
        else {
            var getUrl = window.location;
            return getUrl.protocol + "//" + getUrl.host + "/" + path;
        }
    };
    __decorate([
        vue_property_decorator_1.Prop(String),
        __metadata("design:type", Object)
    ], DataList.prototype, "title", void 0);
    __decorate([
        vue_property_decorator_1.Watch('options.currentPage'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataList.prototype, "setPage", null);
    __decorate([
        vue_property_decorator_1.Watch('options.itemsPerPage'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataList.prototype, "reloadItemsPerPage", null);
    __decorate([
        vue_property_decorator_1.Watch('options.filter', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataList.prototype, "updateFilter", null);
    __decorate([
        vue_property_decorator_1.Watch('options.sortBy'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataList.prototype, "updateSortBy", null);
    __decorate([
        vue_property_decorator_1.Watch('options.sortByDesc'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DataList.prototype, "updateSortByDesc", null);
    DataList = __decorate([
        vue_class_component_1.default({
            name: 'DataList'
        }),
        __metadata("design:paramtypes", [])
    ], DataList);
    return DataList;
}(vue_1.default));
exports.default = DataList;
